import React, { useState } from 'react';
import './Login.css';
import { APP_VERSION_FULL } from '../version';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';
const APP_BRAND = process.env.REACT_APP_BRAND_LABEL || '';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [slowStart, setSlowStart] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSlowStart(false);
    setLoading(true);

    const slowTimer = setTimeout(() => setSlowStart(true), 800);

    try {
      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      clearTimeout(slowTimer);
      setSlowStart(false);

      if (response.status === 429) {
        setError('Too many login attempts. Please wait a minute.');
        setPassword('');
        setLoading(false);
        return;
      }

      const data = await response.json();

      if (response.ok && data.token) {
        sessionStorage.setItem('nexus_token', data.token);
        onLogin();
      } else {
        setError(data.error || 'Invalid username or password');
        setPassword('');
      }
    } catch (err) {
      clearTimeout(slowTimer);
      setSlowStart(false);
      setError('Unable to connect to server');
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <img src="/TA_Logo_2colours.png" alt="Tiller Alpha" className="login-logo" />
          <div className="login-brand-lockup">
            <h1>nexus</h1>
            {APP_BRAND && <div className="login-client-brand">{APP_BRAND}</div>}
          </div>
          {process.env.REACT_APP_DEMO_MODE === 'true' && (
            <div className="demo-badge">Demo · synthetic data</div>
          )}
          <p>Sign in to continue</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
              autoComplete="username"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          {slowStart && (
            <div className="warmup-message">
              <span className="warmup-spinner" />
              Server is starting up — first sign-in may take ~30 seconds.
            </div>
          )}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="login-footer">
          <p>Beta access only • Tiller Alpha</p>
          <p className="login-version">v{APP_VERSION_FULL}</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
